import { createClient } from '@/shared/api';
import type {
  UpdatePatientReturnMutation,
  UpdatePatientReturnMutationVariables,
} from '@/shared/api';
import UPDATE_PATIENT_RETURN_MUTATION from '../mutations/updatePatientReturn';

/**
 * Updates a patient-return record. Runs the updatePatientReturn mutation, throws the returned message when it does not report success and otherwise yields the updated record.
 *
 * @param input - Mutation input describing the patient-return update.
 * @returns A promise resolving to the updated patient return.
 */
const handleUpdatePatientReturn = async (
  input: UpdatePatientReturnMutationVariables['input'],
): Promise<NonNullable<UpdatePatientReturnMutation['updatePatientReturn']>['patientReturn']> => {
  const client = createClient();
  const updatePatientReturnResult = await client.mutate<
    UpdatePatientReturnMutation,
    UpdatePatientReturnMutationVariables
  >({
    mutation: UPDATE_PATIENT_RETURN_MUTATION,
    variables: { input },
  });
  const { data } = updatePatientReturnResult;
  // API always returns this field for a resolved mutation; code already accessed it unconditionally.
  const { updatePatientReturn } = data!;
  if (!updatePatientReturn!.isSuccess) {
    throw new Error(updatePatientReturn!.message ?? undefined);
  }
  return updatePatientReturn!.patientReturn;
};

export default handleUpdatePatientReturn;
